import React, { PureComponent, createRef } from 'react';
import { Map, Marker, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export default class MapComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.onMapClick = this.onMapClick.bind(this);
    this.state = {
      hasLocation: this.props.latitude && this.props.longitude,
      center: {
        lat: 29.631488,
        lng: 52.519806,
      }, // shiraz
      marker: {
        lat: this.props.latitude || 0,
        lng: this.props.longitude || 0,
      },
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.marker.lat !== this.props.latitude ||
      this.state.marker.lng !== this.props.longitude
    ) {
      this.setState(() => ({
        hasLocation: true,
        marker: {
          lat: this.props.latitude,
          lng: this.props.longitude,
        },
        center: {
          lat: this.props.latitude,
          lng: this.props.longitude,
        },
      }));
    }
  }

  onMapClick(e) {
    this.props.onSelectCafeLocation(e.latlng);
    this.setState(() => ({
      hasLocation: true,
      marker: {
        lat: e.latlng.lat,
        lng: e.latlng.lng,
      },
    }));
  }

  render() {
    const marker = this.state.hasLocation ? (
      <Marker position={this.state.marker}></Marker>
    ) : null;

    return (
      <Map
        id='map'
        center={this.state.center}
        zoom={13}
        onclick={!this.props.disabled && this.onMapClick}
      >
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
        {marker}
      </Map>
    );
  }
}
